// Jupiter API Configuration
// All Jupiter API calls should use these constants and the jupiterFetch helper

export const JUPITER_API_KEY = '348dc52d-d8e2-4990-8d5c-e755647a8a2b'

// API Endpoints (using api.jup.ag, not lite-api which is deprecated)
export const JUPITER_SWAP_API = 'https://api.jup.ag/swap/v2'
export const JUPITER_PRICE_API = 'https://api.jup.ag/price/v3'
export const JUPITER_TOKENS_API = 'https://api.jup.ag/tokens/v2'

// Helper to fetch from Jupiter API with auth header
export async function jupiterFetch(
  url: string | URL,
  options?: RequestInit,
): Promise<Response> {
  return fetch(url, {
    ...options,
    headers: {
      'x-api-key': JUPITER_API_KEY,
      ...options?.headers,
    },
  })
}
